export const translations = {
  ru: {
    invite: {
      createPassword: {
        title: 'Создание пароля',
        subtitle: 'Добро пожаловать, {name}<br>Пожалуйста, установите пароль для своего учетной записи.',
        password: {
          placeholder: 'Пароль',
        },
        confirmPassword: {
          placeholder: 'Подтвердите пароль',
        },
        submit: 'Продолжить',
      },
      setupTwoFactorAuth: {
        title: 'Защитите свой аккаунт',
        subtitle: 'Введите 6-значный код из приложения-аутентификатора.',
        code: {
          placeholder: 'Код аутентификатора',
          required: 'Обязательно',
        },
        submit: 'Подтвердить код',
        authApp: {
          instructionsTitle: 'Пошаговая инструкция:',
          googleAuthLabel: 'Google Authenticator',
          microsoftAuthLabel: 'Microsoft Authenticator',
          steps: {
            one: 'Установите приложение-аутентификатор на своё устройство',
            two: 'Отсканируйте указанный QR-код в приложении-аутентификаторе',
            three: 'Введите код из приложения-аутентификатора',
          },
        },
      },
      successView: {
        title: 'Всё готово!',
        subtitle: 'Ваш аккаунт создан.<br>Нажмите ниже, чтобы войти и начать работу.',
        loginBtnLabel: 'Войти',
      },
    },
    passwordFieldChecker: {
      lowerCase: 'Как минимум одна малая литера (a-z)',
      upperCase: 'Как минимум одна великая литера (A-Z)',
      number: 'Как минимум одна цифра',
      count: 'Минимум 8 символов',
    },
    validations: {
      passwordsMismatch: 'Пароли не совпадают',
      required: 'Обязательно поле',
      passwordTooShort: 'Пароль слишком короткий',
      invalidEmail: 'Неверный email',
      invalidCredentials: 'Неверверный пароль или email',
      invalid2FACode: 'Неверный код двухфакторной авторизации',
    },
    login: {
      submitBtn: 'Вход',
      title: 'Авторизация',
      codeSubmitBtn: 'Подтвердить',
      subtitle:
        'Только авторизованные пользователи могут войти в панель управления. Подключаясь, вы даете согласие на сохранение вашего IP-адреса и данных удостоверения личности для вашей проверки.',
    },
    scopes: {
      presets: 'Шаблоны прав',
      presetsTypes: {
        matchAssistant: 'Асистент матча',
        contentEditor: 'Редактор контента',
      },
      teams: 'Команды',
      players: 'Игроки',
      referees: 'Арбитры',
      tournaments: 'Турниры',
      'tour-types': 'Типы туров',
      positions: 'Позиции',
      groups: 'Группы',
      games: 'Матчи',
      admins: 'Администраторы',
      actions: {
        read: 'Просмотр',
        create: 'Создание',
        delete: 'Удаление',
        update: 'Редактирование',
        'edit:without-status': 'Редактирование матчи (без изменения статуса)',
      },
    },
    administrators: {
      role: 'Роль',
      name: 'Имя',
      email: 'Email',
      title: 'Администраторы',
      accounts: 'Аккаунты',
      invites: 'Приглашения',
      scopesDisabledMsg: 'Так как администраторы имеют полный доступ, выбор прав не требуется.',
      accountCreatedMsg: 'Учетная запись успешно создана',
      accountInvitedMsg: 'Пользователь успешно приглашен',
      accountInviteDeletedMsg: 'Приглашение успешно удалено',
      accountDeletedMsg: 'Учетная запись успешно удалена',
      accountUpdatedMsg: 'Учетная запись успешно оновлена',
      deleteTitle: 'Удалить учетную запись {email}?',
      deleteInviteTitle: 'Удалить приглашение для пользователя {email}?',
      details: {
        firstName: 'Имя',
        lastName: 'Фамилия',
        email: 'Email',
        role: 'Роль',
        edit: {
          title: 'Детали учетной записи',
        },
        invite: {
          title: 'Пригласить нового администратора',
        },
      },
    },
    groups: {
      list: 'Список групп',
      titleColumnName: 'Название',
      createdMsg: 'Группа успешно создана',
      deletedMsg: 'Группа успешно удалена',
      updatedMsg: 'Группа успешно оновлена',
      deleteTitle: 'Удалить группу {title}?',
      details: {
        title: 'Детали группы',
        titleField: 'Название',
      },
    },
    positions: {
      list: 'Список позиций',
      titleColumnName: 'Название',
      createdMsg: 'Позиция успешно создана',
      deletedMsg: 'Позиция успешно удалена',
      updatedMsg: 'Позиция успешно оновлена',
      deleteTitle: 'Удалить позицию {title}?',
      details: {
        title: 'Детали',
        titleField: 'Название',
      },
    },
    tourTypes: {
      list: 'Список',
      createdMsg: 'Тур успешно создан',
      deletedMsg: 'Тур успешно удален',
      updatedMsg: 'Тур успешно обновлен',
      deleteTitle: 'Удалить тур {title}?',
      details: {
        nameField: 'Название',
        title: 'Детали',
        titleField: 'Название',
      },
    },
    players: {
      name: 'Имя',
      title: 'Игроки',
      list: 'Список игроков',
      playerCreatedMsg: 'Игрок успешно создан',
      playerDeletedMsg: 'Игрок успешно удален',
      playerUpdatedMsg: 'Игрок успешно оновлен',
      deleteTitle: 'Удалить игрока {name}?',
      searchPlaceholder: 'Искать',
      details: {
        title: 'Детали',
        firstName: 'Имя',
        lastName: 'Фамилия',
        middleName: 'Отчество',
        dateOfBirth: 'Дата рождения',
      },
    },
    referees: {
      name: 'Имя',
      title: 'Арбитры',
      list: 'Список игроков',
      refereeCreatedMsg: 'Арбитр успешно создан',
      refereeDeletedMsg: 'Арбитр успешно удален',
      refereeUpdatedMsg: 'Арбитр успешно оновлен',
      deleteTitle: 'Удалить арбитра {name}?',
      searchPlaceholder: 'Искать',
      details: {
        title: 'Детали',
        firstName: 'Имя',
        lastName: 'Фамилия',
        middleName: 'Отчество',
        dateOfBirth: 'Дата рождения',
      },
    },
    tournaments: {
      name: 'Имя',
      title: 'Tурниры',
      tableType: 'Таблица',
      groupType: 'Групповой',
      cupType: 'Кубок',
      list: 'Список турниров',
      tournamentCreatedMsg: 'Tурнир успешно создан',
      tournamentDeletedMsg: 'Tурнир успешно удален',
      tournamentUpdatedMsg: 'Tурнир успешно оновлен',
      tournamentPhotosUpdatedMsg: 'Фотографии успешно обновлены',
      tournamentSyncedMsg: 'Турнир успешно синхронизирован',
      deleteTitle: 'Удалить турнир {name}?',
      create: {
        title: 'Создать новый турнир',
        fieldTitle: 'Название',
        fieldParentTournament: 'Выберите турнир, к которому относится этот турнир',
        fieldStartedAt: 'Дата начала',
        fieldAbout: 'Про турнир',
        fieldType: 'Тип турнира',
        fieldExtraPoints: 'Дополнительные очки при ничейном исходе матча',
        field10mPenalty: '10м удар при 6 и более нарушениях в матче',
      },
    },
    tournament: {
      tabs: {
        general: 'Инфо',
        teams: 'Команды',
        schedule: 'Игры',
        knockout: 'Сетка на выбывание',
        media: 'Фото',
        results: 'Результаты',
      },
      childTournaments: {
        title: 'Дочерние турниры',
      },
      media: {
        hintMaxPhotos: 'Максимальное количество фотографий — {count}',
        hintAlreadyUploaded: 'Уже загружено {count} фотографий',
        hintMaxSize:
          'Максимальный размер файла — {size}. Если вы добавляете файл больше размера, он просто не загрузится',
      },
      syncTournamentNotes: {
        p1: 'Данный турнир был создан на основе другого турнира. В связи с этим необходимо выполнить синхронизацию команд и их составов, которые будут участвовать в текущем турнире.',
        p2: 'Синхронизация позволяет перенести команды и связанных с ними игроков из базового турнира и обеспечивает корректную работу матчей, статистики и других функциональных возможностей турнира.',
        optionsTitle: 'Вы можете выполнить синхронизацию одним из двух способов:',
        optionOneTitle: 'Ручная синхронизация',
        optionOneContent:
          'Предполагает самостоятельное добавление команд, а также формирование их составов путем выбора или создания необходимых игроков. Данный способ рекомендуется в случаях, когда составы команд в текущем турнире отличаются от базового турнира или требуют индивидуальных изменений.',
        optionTwoTitle: 'Автоматическая синхронизация',
        optionTwoContent:
          'При выборе данного способа все команды и их составы будут автоматически добавлены из турнира, на основе которого был создан данный турнир. Этот вариант рекомендуется использовать, если структура команд и составы игроков остаются без изменений.',
        footerText:
          'Обратите внимание, что без выполнения синхронизации участие команд в турнире, а также корректное отображение данных, может быть ограничено.',
      },
      teams: {
        duplicationErrorMsg: 'Команда уже добавлена в этот турнир',
        updatedMsg: 'Команда успешно обновлена',
        createdMsg: 'Команду успешно добавлена',
        deleteTeamTitle: 'Удалить команду {name} из турнира. Данные о составе команды так же будут утеряны',
        deletedTeamMsg: 'Команда успешно удалена из турнира',
        details: {
          title: 'Добавить команду',
          editTitle: 'Редактировать команду',
          groupTitle: 'Группа',
          teamTitle: 'Команда',
          extraPointsTitle: 'Дополнительные очки',
        },
      },
      schedule: {
        duplicationErrorMsg: 'Игра {title} уже существует в этом турнире',
        updatedMsg: 'Игра успешно обновлена',
        createdMsg: 'Игра успешно добавлена',
        deleteGameTitle: 'Удалить игру {title} из турнира?',
        deletedGameMsg: 'Игра {title} успешно удалена из турнира',
        protocolTooltip: 'Скачать протокол игры',
        details: {
          title: 'Добавить игру',
          editTitle: 'Редактировать игру',
          teamOneTitle: 'Команда 1',
          teamTwoTitle: 'Команда 2',
          teamOneGoalsTitle: 'Кол-во голов Команды 1',
          teamTwoGoalsTitle: 'Кол-во голов Команды 2',
          teamOnePenaltyGoalsTitle: 'Кол-во голов Команды 1 (пенальти)',
          teamTwoPenaltyGoalsTitle: 'Кол-во голов Команды 2 (пенальти)',
          teamOnePlaceholder: 'Заголовок Команды 1',
          teamTwoPlaceholder: 'Заголовок Команды 2',
          selectedCount: 'Выбрано {count} игроков',
          statusTitle: 'Статус игры',
          date: 'Дата игры',
          time: 'Время игры',
          postponementDateTime: 'Время переноса',
          postponeLabel: 'Игра перенесена',
          problematicGame: 'Техническое поражение',
          postponementDate: 'Дата переноса',
          notesLabel: 'Заметки',
          tourTitle: 'Выберите тур',
          noMembershipData: 'Судя по всему, вы забыли добавить игроков в команду',
          participantsNotConsistent:
            'В заявке отсутствуют игроки, указанные в статистике («Голы», «Асистенты», «Нарушения»). Необходимо либо добавить этих игроков в заявку, либо удалить соответствующие записи из статистики',
          membershipAlertMsg:
            'Эта вкладка будет доступна только после создания игры и указания команд, которые будут участвовать в этой игре.',
          participantAlertMsg: 'Эта вкладка будет доступна только после создания игры и заполнения заявок команд',
          gameAlertMsg: 'Эта вкладка будет доступна только после создания игры',
          tabs: {
            general: 'Общие',
            goals: 'Голы',
            fouls: 'Нарушения',
            passes: 'Асистенты',
            gameParticipants: 'Заявка',
            referees: 'Арбитры',
          },
        },
        status: {
          default: 'Новая',
          underReview: 'На рассмотрении',
          finished: 'Завершена',
          canceled: 'Отменена',
        },
      },
      results: {
        firstTeamTitle: 'Команда победитель',
        secondTeamTitle: 'Команда  2-е место',
        thirdTeamTitle: 'Команда 3-е место',
        bestPlayerTitle: 'Лучший игрок',
        bestGoalkeeperTitle: 'Лучший вратарь',
        topScorerTitle: 'Лучший бомбардир',
        bestAssistantTitle: 'Лучший ассистент',
      },
      teamMembership: {
        details: {
          title: 'Cостав команды "{team}"',
          addPositionPlaceholder: 'Выбрать позицию',
          addStatusPlaceholder: 'Статус игрока',
          playerNumber: 'Номер',
          createMsg: 'Игрок был успешно добавлен в состав команды',
          updateMsg: 'Игрок был успешно обновлен',
          deleteTitle: 'Вы действительно хотите удалить игрока {name} из команды в данном турнире?',
          deletedTitleMsg: 'Игрок был успешно удален из команди {teamName} в данном турнире',
          duplicationErrorMsg: 'Игрок уже в составе команды',
          startParticipateLabel: 'Дата начала участия',
          endParticipateLabel: 'Дата исключения',
          membersTotal: 'В заявке: {total} чел.',
          importErrorMsg: 'Эта команда ещё не участвовала ни в одном турнире, поэтому нет данных для импорта игроков.',
          importPlayersMsg:
            'Если команда участвовала в предыдущем турнире, вы можете импортировать список игроков. Вы также сможете удалить или добавить игроков в соответствии с заявкой на этот турнир.',
          importBtnLabel: 'Импортировать',
          status: {
            active: 'Активен',
            inactive: 'Неактивен',
            transferIn: 'Переход из другой команды',
            transferOut: 'Переход в другую команду',
          },
        },
      },
    },
    teams: {
      name: 'Название',
      title: 'Команды',
      list: 'Список игроков',
      teamCreatedMsg: 'Команда успешно создана',
      teamDeletedMsg: 'Команда успешно удалена',
      teamUpdatedMsg: 'Команда успешно оновлена',
      deleteTitle: 'Удалить команду {name}?',
      details: {
        title: 'Детали команды',
        name: 'Название',
        foundedYear: 'Год создания',
      },
    },
    welcome: {
      title: 'Добро пожаловать в панель администратора',
      text: 'Здесь вы можете управлять основными данными и настройками системы. Используйте навигацию слева для доступа к нужным разделам. Все изменения внесённые в панели, применяются к рабочей версии проекта. Пожалуйста, проверяйте данные перед сохранением. В случае необходимости используйте доступные инструменты управления и контроля',
    },
    games: {
      title: 'Матчи',
      selectTournamentInputLabel: 'Выберите турнир',
      selectGameStatusLabel: 'Статус игры',
    },
    navigation: {
      settings: 'Настройки',
    },
    roles: {
      admin: 'Администратор',
      developer: 'Разработчик',
      editor: 'Редактор',
    },
    dropzone: {
      activeDropLabel: 'Отпустите изображения здесь...',
      inactiveDropLabel: 'Перетащите фото сюда или нажмите для выбора',
      hint: 'Только изображения (PNG, JPG, WEBP)',
      loaderLabel: 'Подождите, пожалуйста, идет загрузка...',
    },
    general: {
      inviteBtnLabel: 'Пригласить',
      pageNoAccessTitle: 'Вы не можете просматривать эту страницу',
      sync: 'Синхронизация',
      teamOne: 'Команда 1',
      teamTwo: 'Команда 2',
      unknown: 'Неопределено',
      dateAndTime: 'Дата и время',
      type: 'Тип',
      actions: 'Действия',
      email: 'Email',
      twoFactorCode: 'Код двухфакторной авторизации',
      selectPlayerPlaceholder: 'Выбрать игрока',
      password: 'Пароль',
      tournaments: 'Турниры',
      addGoal: 'Добавить гол',
      addReferee: 'Добавить арбитра',
      addFoul: 'Добавить нарушение',
      cardReason: 'За что?',
      addAssistant: 'Добавить асистена',
      selectCardPlaceholder: 'Выбрать карточку',
      selectRefereePlaceholder: 'Выбрать арбитра',
      cards: {
        yellow: 'Жёлтая',
        red: 'Красная',
      },
      columnNameTitle: 'Название',
      columnScoreTitle: 'Счёт',
      columnStatusTitle: 'Статус',
      tourTypes: 'Типы туров',
      admins: 'Администраторы',
      games: 'Матчи',
      minute: 'Минута',
      ownGoal: 'Автогол',
      fromPenaltyGoal: 'С пенальти',
      from10mGoal: 'С 10м пенальти',
      groups: 'Группы',
      referees: 'Арбитры',
      positions: 'Позиции игроков',
      players: 'Игроки',
      noData: 'Нет данных',
      loading: 'Загрузка',
      teams: 'Команды',
      addBtnLabel: 'Добавить',
      createBtnLabel: 'Создать',
      updateBtnLabel: 'Обновить',
      deleteBtnLabel: 'Удалить',
      cancelBtnLabel: 'Отмена',
      membership: 'Состав',
      continueBtnLabel: 'Продолжить',
      generalErrorMsg: 'Что-то пошло не так. Пожалуйста, попробуйте позже',
      saveBtnLabel: 'Сохранить',
      saveAndCloseBtnLabel: 'Сохранить и закрыть',
      loadingLabel: 'Загрузка',
      updateLabel: 'Oбновить',
      closeLabel: 'Закрыть',
      clearLabel: 'Очистить',
      number: 'Номер',
      fio: 'ФИО игрока',
      status: 'Статус',
      position: 'Позиция',
      unsavedDataTitle: 'Несохранённые данные будут потеряны. Продолжить?',
    },
  },
  ua: {
    invite: {
      createPassword: {
        title: 'Створення пароля',
        subtitle: 'Вітаємо, {name}<br>Будь ласка, встановіть пароль для свого облікового запису.',
        password: {
          placeholder: 'Пароль',
        },
        confirmPassword: {
          placeholder: 'Підтвердіть пароль',
        },
        submit: 'Продовжити',
      },
      setupTwoFactorAuth: {
        title: 'Захистіть свій обліковий запис',
        subtitle: 'Введіть 6-значний код із вашого застосунку автентифікації.',
        code: {
          placeholder: 'Код автентифікатора',
          required: 'Обовʼязково',
        },
        submit: 'Підтвердити код',
        authApp: {
          instructionsTitle: 'Покрокова інструкція:',
          googleAuthLabel: 'Google Authenticator',
          microsoftAuthLabel: 'Microsoft Authenticator',
          steps: {
            one: 'Встановіть застосунок автентифікації на свій пристрій',
            two: 'Відскануйте наведений QR-код у застосунку автентифікації',
            three: 'Введіть код із застосунку автентифікації',
          },
        },
      },
      successView: {
        title: 'Усе готово!',
        subtitle: 'Ваш обліковий запис створено.<br>Натисніть нижче, щоб увійти та почати роботу.',
        loginBtnLabel: 'Увійти',
      },
    },
    passwordFieldChecker: {
      lowerCase: 'Як мінімум одна мала літера (a-z)',
      upperCase: 'Як мінімум одна велика літера (A-Z)',
      number: 'Як мінімум одна цифра',
      count: 'Мінімум 8 символів',
    },
    validations: {
      passwordsMismatch: 'Паролі не співпадають',
      required: 'Обовʼязкове поле',
      passwordTooShort: 'Пароль занадто короткий',
      invalidEmail: 'Неправильний email',
      invalidCredentials: 'Неправильний пароль або email',
      invalid2FACode: 'Неправильний код двухфакторної автентифікації',
    },
    login: {
      submitBtn: 'Вхід',
      codeSubmitBtn: 'Відправити код',
      title: 'Авторизація',
      subtitle:
        'Тільки авторизовані користувачі можуть увійти до панелі керування. Підключаючись, ви даєте згоду на збереження вашої IP-адреси та даних ідентифікації для вашої перевірки.',
    },
    scopes: {
      presets: 'Шаблони прав',
      presetsTypes: {
        matchAssistant: 'Асистент матчу',
        contentEditor: 'Редактор контента',
      },
      teams: 'Команди',
      players: 'Гравці',
      referees: 'Судді',
      tournaments: 'Турніри',
      'tour-types': 'Типи турів',
      positions: 'Позиції',
      groups: 'Групи',
      games: 'Матчі',
      admins: 'Адміністратори',
      actions: {
        read: 'Перегляд',
        create: 'Створення',
        delete: 'Видалення',
        update: 'Редагування',
        'edit:without-status': 'Редагування матчу (без зміни статусу)',
      },
    },
    administrators: {
      role: 'Роль',
      name: 'Імʼя',
      email: 'Email',
      title: 'Адміністратори',
      accounts: 'Акаунти',
      invites: 'Запрошення',
      scopesDisabledMsg: 'Оскільки адміністратори мають повний доступ, обирати права не потрібно.',
      accountCreatedMsg: 'Обліковий запис успішно створено',
      accountInvitedMsg: 'Користувача успішно запрошено',
      accountDeletedMsg: 'Обліковий запис успішно видалено',
      accountInviteDeletedMsg: 'Запрошення успішно видалено',
      accountUpdatedMsg: 'Обліковий запис успішно оновлено',
      deleteTitle: 'Видалити обліковий запис {email}?',
      deleteInviteTitle: 'Видалити запрошення для користувача {email}?',
      details: {
        firstName: 'Імʼя',
        lastName: 'Прізвище',
        email: 'Email',
        role: 'Роль',
        edit: {
          title: 'Деталі облікового запису',
        },
        invite: {
          title: 'Запросити нового адміністратора',
        },
      },
    },
    welcome: {
      title: 'Ласкаво просимо до панелі адміністратора',
      text: 'Тут ви можете керувати основними даними та налаштуваннями системи. Використовуйте навігацію ліворуч для доступу до потрібних розділів. Усі зміни, внесені в панелі, застосовуються до робочої версії проєкту. Будь ласка, перевіряйте дані перед збереженням. У разі потреби використовуйте доступні інструменти керування та контролю',
    },
    games: {
      title: 'Матчі',
      selectTournamentInputLabel: 'Оберіть турнір',
      selectGameStatusLabel: 'Cтатус гри',
    },
    groups: {
      list: 'Список груп',
      titleColumnName: 'Назва',
      createdMsg: 'Група успішно створена',
      deletedMsg: 'Група успішно видалена',
      updatedMsg: 'Група успішно оновлена',
      deleteTitle: 'Видалити группу {title}?',
      details: {
        title: 'Деталі',
        titleField: 'Назва',
      },
    },
    positions: {
      list: 'Список позицій',
      titleColumnName: 'Назва',
      createdMsg: 'Позиція успішно створена',
      deletedMsg: 'Позиція успішно видалена',
      updatedMsg: 'Позиція успішно оновлена',
      deleteTitle: 'Видалити позицію {title}?',
      details: {
        title: 'Деталі',
        titleField: 'Назва',
      },
    },
    tourTypes: {
      list: 'Список',
      createdMsg: 'Тур успішно створен',
      deletedMsg: 'Тур успішно видален',
      updatedMsg: 'Тур успішно оновлен',
      deleteTitle: 'Видалити Тур {title}?',
      details: {
        nameField: 'Назва',
        title: 'Деталі',
        titleField: 'Назва',
      },
    },
    players: {
      name: 'Імʼя',
      title: 'Гравці',
      list: 'Список гравців',
      playerCreatedMsg: 'Гравець успішно створен',
      playerDeletedMsg: 'Гравеця успішно видалено',
      playerUpdatedMsg: 'Гравець успішно оновлен',
      deleteTitle: 'Видалити гравця {name}?',
      searchPlaceholder: 'Шукати',
      details: {
        title: 'Деталі',
        firstName: 'Імʼя',
        lastName: 'Прізвище',
        middleName: 'По батькові',
        dateOfBirth: 'Дата народження',
      },
    },
    referees: {
      name: 'Імʼя',
      title: 'Арбітри',
      list: 'Список арбітрів',
      refereeCreatedMsg: 'Арбітр успішно створен',
      refereeDeletedMsg: 'Арбітра успішно видалено',
      refereeUpdatedMsg: 'Арбітр успішно оновлен',
      deleteTitle: 'Видалити арбітра {name}?',
      searchPlaceholder: 'Шукати',
      details: {
        title: 'Деталі',
        firstName: 'Імʼя',
        lastName: 'Прізвище',
        middleName: 'По батькові',
        dateOfBirth: 'Дата народження',
      },
    },
    tournaments: {
      name: 'Назва',
      title: 'Tурніри',
      tableType: 'Таблиця',
      groupType: 'Груповий',
      cupType: 'Кубок',
      list: 'Список турнірів',
      tournamentCreatedMsg: 'Турнір успішно створен',
      tournamentDeletedMsg: 'Турнір успішно видален',
      tournamentUpdatedMsg: 'Турнір успішно оновлен',
      tournamentPhotosUpdatedMsg: 'Фотографії успішно оновлені',
      tournamentSyncedMsg: 'Турнір успішно синхронізован',
      deleteTitle: 'Видалити турнір {name}?',
      create: {
        title: 'Cтворити новий турнір',
        fieldTitle: 'Назва',
        fieldParentTournament: 'Оберіть турнір, до якого належить цей турнір',
        fieldStartedAt: 'Дата початку',
        fieldAbout: 'Про турнір',
        fieldType: 'Тип турніру',
        fieldExtraPoints: 'Додаткові очки при нічийному результаті матчу',
        field10mPenalty: '10м удар при 6 і більше порушеннях у матчі',
      },
    },
    tournament: {
      tabs: {
        general: 'Інфо',
        teams: 'Команди',
        schedule: 'Ігри',
        knockout: 'Сітка на вибування',
        media: 'Фото',
        results: 'Результати',
      },
      teams: {
        duplicationErrorMsg: 'Команда вже додана до цього турніру',
        updatedMsg: 'Команду успішно оновлено',
        createdMsg: 'Команду успішно додано',
        deleteTeamTitle: 'Видалити команду {name} з турніру. Дані про склад команди також буде втрачено!',
        deletedTeamMsg: 'Команда успішно видалена з турніру',
        details: {
          title: 'Додати команду',
          editTitle: 'Редагувати команду',
          groupTitle: 'Група',
          teamTitle: 'Команда',
          extraPointsTitle: 'Додаткові очки',
        },
      },
      media: {
        hintMaxPhotos: 'Максимальна кількість фотографій — {count}',
        hintAlreadyUploaded: 'Вже завантажено {count} фотографій',
        hintMaxSize:
          'Максимальний розмір файлу — {size}. Якщо ви додаєте файл більше розміру, він просто не завантажиться',
      },
      childTournaments: {
        title: 'Дочерні турніри',
      },
      syncTournamentNotes: {
        p1: 'Даний турнір було створено на основі іншого турніру. У зв’язку з цим необхідно виконати синхронізацію команд та їхніх складів, які братимуть участь у поточному турнірі.',
        p2: 'Синхронізація дозволяє перенести команди та пов’язаних із ними гравців із базового турніру та забезпечити коректну роботу матчів, статистики та інших функцій турніру.',
        optionsTitle: 'Ви можете виконати синхронізацію одним із двох способів:',
        optionOneTitle: 'Ручна синхронізація',
        optionOneContent:
          'Передбачає самостійне додавання команд, а також формування їхніх складів шляхом вибору або створення необхідних гравців. Даний спосіб рекомендується у випадках, коли склад команд у поточному турнірі відрізняється від базового турніру або потребує індивідуальних змін.',
        optionTwoTitle: 'Автоматична синхронізація',
        optionTwoContent:
          'При виборі цього способу всі команди та їхні склади будуть автоматично додані з турніру, на основі якого було створено даний турнір. Цей варіант є рекомендованим, якщо структура команд і склади гравців залишаються без змін.',
        footerText:
          'Зверніть увагу, що без виконання синхронізації участь команд у турнірі та коректне відображення даних можуть бути обмежені.',
      },
      schedule: {
        duplicationErrorMsg: 'Гра {title} вже існує в цьому турнирі',
        updatedMsg: 'Гру було успішно оновлено',
        createdMsg: 'Гру було успішно додано до турниру',
        deleteGameTitle: 'Видалити гру {title} з турнира?',
        deletedGameMsg: 'Гру {title} було успішно видалено з турниру',
        protocolTooltip: 'Скачати протокол гри',
        details: {
          title: 'Додати гру',
          editTitle: 'Редагувати гру',
          teamOneTitle: 'Команда 1',
          teamTwoTitle: 'Команда 2',
          statusTitle: 'Статус гри',
          teamOneGoalsTitle: 'Кiлькість голів Команди 1',
          teamOnePenaltyGoalsTitle: 'Кількість голів Команди 1 (пенальті)',
          teamTwoGoalsTitle: 'Кількість голів Команди 2',
          teamTwoPenaltyGoalsTitle: 'Кількість голів Команди 2 (пенальті)',
          teamOnePlaceholder: 'Заголовок Команди 1',
          teamTwoPlaceholder: 'Заголовок Команди 2',
          selectedCount: 'Вибрано {count} гравців',
          date: 'Дата гри',
          time: 'Час гри',
          postponementDateTime: 'Час переносу',
          postponementDate: 'Дата переносу',
          postponeLabel: 'Гру перенесено',
          problematicGame: 'Технічна поразка',
          notesLabel: 'Hотатки',
          tourTitle: 'Оберiть тур',
          noMembershipData: 'Cхоже, ви забули додати гравців до команди',
          participantsNotConsistent:
            'У заявці відсутні гравці, які вказані у статистиці («Голи», «Асистенти», «Порушення»). Необхідно або додати цих гравців до заявки, або видалити відповідні записи зі статистики',
          membershipAlertMsg:
            'Ця вкладка буде доступна лише після створення гри та вказання команд, які братимуть участь у цій грі.',
          participantAlertMsg: 'Ця вкладка буде доступна лише після створення гри та заповнення заявок команд',
          gameAlertMsg: 'Ця вкладка буде доступна лише після створення гри',
          tabs: {
            general: 'Загальні',
            goals: 'Голи',
            fouls: 'Порушення',
            passes: 'Асистенти',
            gameParticipants: 'Заявка',
            referees: 'Арбітри',
          },
        },
        status: {
          default: 'Нова',
          underReview: 'На розгляді',
          finished: 'Завершено',
          canceled: 'Cкасовано',
        },
      },
      results: {
        firstTeamTitle: 'Команда переможець',
        secondTeamTitle: 'Команда  2 місце',
        thirdTeamTitle: 'Команда 3 місце',
        bestPlayerTitle: 'Кращий гравець',
        bestGoalkeeperTitle: 'Кращий воратар',
        topScorerTitle: 'Кращий бомбардир',
        bestAssistantTitle: 'Кращий ассистент',
      },
      teamMembership: {
        details: {
          title: 'Склад команди "{team}"',
          addPositionPlaceholder: 'Вибрати позицію',
          addStatusPlaceholder: 'Статус гравця',
          playerNumber: 'Номер',
          createMsg: 'Гравця було успішно додано до складу команди',
          updateMsg: 'Гравця було успішно оновлено',
          deleteTitle: 'Ви дійсно бажаєте видалити гравця {name} з команди на цьому турнирі?',
          deletedTitleMsg: 'Гравця було успішно видалено з команди {teamName} на цьому турнирі',
          duplicationErrorMsg: 'Гравeць вже у складі команди',
          startParticipateLabel: 'Дата початку участі',
          endParticipateLabel: 'Дата вилучення',
          membersTotal: 'У заявці: {total} чол.',
          importErrorMsg: 'Ця команда ще не брала участі в жодному турнірі, тому немає даних для імпорту гравців.',
          importPlayersMsg:
            'Якщо команда брала участь у попередньому турнірі, ви можете імпортувати список гравців. Ви також зможете видалити або додати гравців згідно заявки на цей турнір.',
          importBtnLabel: 'Імпортувати',
          status: {
            active: 'Активний',
            inactive: 'Неактивний',
            transferIn: 'Перехід з іншої команди',
            transferOut: 'Перехід в іншу команду',
          },
        },
      },
    },
    teams: {
      name: 'Назва',
      title: 'Команди',
      list: 'Список команд',
      teamCreatedMsg: 'Комадна успішно створена',
      teamDeletedMsg: 'Комадну успішно видалено',
      teamUpdatedMsg: 'Команда успішно оновлена',
      deleteTitle: 'Видалити команду {name}?',
      details: {
        title: 'Деталі команди',
        name: 'Назва',
        foundedYear: 'Рік створення',
      },
    },
    navigation: {
      settings: 'Налаштування',
    },
    roles: {
      admin: 'Адміністратор',
      developer: 'Розробник',
      editor: 'Редактор',
    },
    dropzone: {
      activeDropLabel: 'Відпустіть зображення сюди...',
      inactiveDropLabel: 'Перетягніть зображення сюди або натисніть для вибору',
      hint: 'Тільки зображення (PNG, JPG, WEBP)',
      loaderLabel: 'Зачекайте, будь ласка, триває завантаження...',
    },
    general: {
      inviteBtnLabel: 'Запросити',
      pageNoAccessTitle: 'Ви не маєте дозволу переглядати цю сторінку',
      sync: 'Синхронізація',
      teamOne: 'Команда 1',
      teamTwo: 'Команда 2',
      unknown: 'Невідомо',
      dateAndTime: 'Дата і час',
      type: 'Тип',
      email: 'Email',
      twoFactorCode: 'Код двухфакторної автентифікації',
      actions: 'Дії',
      password: 'Пароль',
      selectPlayerPlaceholder: 'Вибрати гравця',
      minute: 'Хвилина',
      ownGoal: 'Автогол',
      fromPenaltyGoal: 'З пенальті',
      from10mGoal: 'З 10м пенальті',
      tournaments: 'Турніри',
      columnNameTitle: 'Назва',
      columnScoreTitle: 'Рахунок',
      columnStatusTitle: 'Статус',
      admins: 'Адміністратори',
      tourTypes: 'Типи турів',
      addGoal: 'Додати гол',
      referees: 'Арбітри',
      addReferee: 'Додати арбітра',
      addFoul: 'Додати порушення',
      cardReason: 'За що?',
      addAssistant: 'Додати асистена',
      selectCardPlaceholder: 'Вибрати карточку',
      selectRefereePlaceholder: 'Вибрати арбітра',
      cards: {
        yellow: 'Жовта',
        red: 'Красна',
      },
      groups: 'Групи',
      positions: 'Позиціі гравців',
      players: 'Гравці',
      games: 'Матчі',
      noData: 'Немає даних',
      loading: 'Загрузка',
      teams: 'Команди',
      addBtnLabel: 'Додати',
      createBtnLabel: 'Створити',
      updateBtnLabel: 'Обновити',
      membership: 'Скад',
      deleteBtnLabel: 'Видалити',
      cancelBtnLabel: 'Відміна',
      continueBtnLabel: 'Продовжити',
      generalErrorMsg: 'Щось пішло не так. Будь ласка, спробуйте пізніше',
      saveBtnLabel: 'Зберегти',
      saveAndCloseBtnLabel: 'Зберегти та вийти',
      loadingLabel: 'Загрузка',
      updateLabel: 'Oновити',
      closeLabel: 'Закрити',
      clearLabel: 'Очистити',
      fio: 'ПІБ гравця',
      number: 'Номер',
      status: 'Статус',
      position: 'Позиція',
      unsavedDataTitle: 'Незбережені дані буде втрачено. Продовжити?',
    },
  },
};
